"use client";

import { Layout } from "@/modules/deployment/embeded";

export default Layout;
